import { normalizeTimeZone } from '@shared/calendarDay';

/** A display/default suggestion only. It never overrides the saved practice zone. */
export function getDeviceTimeZone(): string | null {
  try {
    return normalizeTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  } catch {
    return null;
  }
}
